export const palette = {
  background: {
    default: '#F9FAFB',
    paper: '#FFFFFF',
  },
  primary: {
    main: '#2169F5',
    light: '#2169F5',
    dark: '#0F347C',
    contrast: '#FFFFFF',
  },
  secondary: {
    main: '#FFCD75',
    light: '#0000009A',
    dark: '#377DCE',
    contrast: '#FFFFFF',
  },
  error: {
    main: '#D32F2F',
    light: '#EF5350',
    dark: '#C62828',
    contrast: '#FFFFFF',
  },
  warning: {
    main: '#FB8C00',
    light: '#FF9800',
    dark: '#E65100',
    contrast: '#FFFFFF',
  },
  info: {
    main: '#0288D1',
    light: '#E6F3FE',
    dark: '#01579B',
    contrast: '#FFFFFF',
  },
  success: {
    main: '#2E7D32',
    light: '#4CAF50',
    dark: '#1B5E20',
    contrast: '#FFFFFF',
  },
};

export const otherColors = {
  apptHover: '#F4F6F8',
  blackTransparent: 'rgba(0, 0, 0, 0.5)',
  cardBackground: 'rgba(33, 105, 245, 0.04)',
  cardChip: '#7CB342',
  closeCross: '#773602CC',
  consentBorder: 'rgba(77, 21, 183, 0.5)',
  dialogNote: '#FCD29973',
  disabled: 'rgba(0,0,0,0.38)',
  disabledBackground: 'rgba(0, 0, 0, 0.12)',
  dottedLine: '#BFC2C6',
  employeeActiveChip: '#C8E6C9',
  employeeActiveText: '#1B5E20',
  employeeBeenSeenChip: '#D1C4E9',
  employeeBeenSeenText: '#311B92',
  employeeDeactivatedChip: '#FECDD2',
  employeeDeactivatedText: '#B71C1C',
  endCallButton: '#EB5757',
  formCardBg: '#F7F8F9',
  infoBackground:
    'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), linear-gradient(0deg, #0288D1, #0288D1)',
  infoIcon: '#0288D1',
  infoText: 'linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), linear-gradient(0deg, #0288D1, #0288D1)',
  green700: '#388E3C',
  lightBlue: '#E2F0FF',
  lightDivider: 'rgba(0, 0, 0, 0.12)',
  lightIconButton: '#EDE8FF',
  locationGeneralBlue: '#CFF5FF',
  none: '#00000061',
  orange100: '#FFE0B2',
  orange700: '#F57C00',
  orange800: '#EF6C00',
  priorityHighIcon: '#F44336',
  priorityHighText: '#E53935',
  selectMenuHover: '#F8F6FC',
  solidLine: '#DFE5E9',
  tableRow: 'rgba(0,0,0,0.87)',
  warningBackground:
    'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), linear-gradient(0deg, #ED6C02, #ED6C02)',
  warningIcon: '#ED6C02',
  warningText: '#5F2B00',
  warningBorder: '#EF9A9A',
  infoAlert: '#e3f2fd',
  sidebarItemHover: '#F6F9FF',
  lightErrorBg: '#FBEAEA',
  lightErrorText: '#541313',
  lightGreen: '#EAF2EA',
  darkGreenText: '#123214',
  lightBlue600: '#039BE5',

  // Scheduled patient outreach feature.
  // Status tints, medium/action accents, and history-dialog colors used by the
  // outreach UI. Semantic "main" colors come from `palette` (success/error/warning);
  // these are the supporting tints/extras that the palette doesn't define.
  outreachSurfaceMuted: '#F5F5F5',
  outreachNeutralMain: '#757575',
  outreachNeutralText: '#616161',
  outreachNeutralBg: '#EEEEEE',
  outreachNeutralAvatar: '#E0E0E0',
  outreachSuccessBg: '#C8E6C9',
  outreachSuccessBgSubtle: '#E8F5E9',
  outreachErrorText: '#B71C1C',
  outreachErrorBg: '#FFCDD2',
  outreachErrorBgSubtle: '#FFEBEE',
  outreachWarningBg: '#FFE0B2',
  outreachWarningBgSubtle: '#FFF3E0',
  outreachInfoMain: '#1976D2',
  outreachInfoDark: '#1565C0',
  outreachInfoText: '#0D47A1',
  outreachInfoBg: '#BBDEFB',
  outreachInfoBgSubtle: '#E3F2FD',
  outreachPendingText: '#7A5E00',
  outreachPendingBg: '#FFF3CD',
  outreachPurpleText: '#4A148C',
  outreachPurpleBg: '#F3E5F5',
  outreachMediumSms: '#43A047',
  outreachMediumEmail: '#0277BD',
  outreachMediumPaperMail: '#4E342E',
  outreachActionLog: '#546E7A',
  outreachPaperMailButton: '#6D4C41',
  outreachPaperMailButtonHover: '#5D4037',
};
